//
export default [
    {
        text: '#',
        value: 'pch_purchase_order_id',
    },
    {
        text: 'responsable',
        value: 'g_originator_user_full_name',
    },
    {
        text: 'proveedor',
        value: 'pch_provider_alias_name',
    },
    {
        text: 'fecha de creación',
        value: 'created_at',
        format: 'datetime',
        align: 'right',
    },
    {
        text: 'fecha de autorización',
        value: 'authorization_date',
        format: 'datetime',
        align: 'right',
    },
    {
        text: 'estado',
        value: 'pch_purchase_order_state_name',
        align: 'center',
        component: {
            type: 'chip-label',
            props: {
                colors: {
                    cerrada: 'grey darken-4 white--text',
                    creada: 'accent lighten-3',
                    enviada: 'secondary lighten-3',
                    autorizada: 'success lighten-3',
                    cerrada_parcialmente: 'info lighten-3',
                    rechazada: 'error lighten-3',
                },
                noEvents: true,
                small: true,
            },
        },
    },
    {
        text: 'total',
        value: 'total',
        format: 'currency',
        align: 'right',
    },
]
